import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../../query.client';
import billingService from './billing.service';
import type { Currency } from './billing.types';

export const usePrices = (teamId: string, currency: Currency) => {
  return useQuery({
    queryKey: [QueryKeys.PRICES, teamId, currency],
    queryFn: () => billingService.listPrices(teamId, currency),
    enabled: !!teamId && !!currency,
  });
};
